import { render, staticRenderFns } from "./VipItem.vue?vue&type=template&id=fe2d8102&scoped=true&"
import script from "./VipItem.vue?vue&type=script&lang=js&"
export * from "./VipItem.vue?vue&type=script&lang=js&"
import style0 from "./VipItem.vue?vue&type=style&index=0&id=fe2d8102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2d8102",
  null
  
)

export default component.exports